import { styled, SxProps, TextField, TextFieldProps, Theme } from '@mui/material';

export const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  ...DefaultSx,
  '& .MuiInputLabel-root': {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '21px',
    letterSpacing: '0%',
    color: theme.palette.text.secondary,
    '&.Mui-focused': {
      color: theme.palette.text.secondary
    }
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    backgroundColor: '#fff',
    '& fieldset': {
      borderRadius: '10px'
    }
  }
}));

export const DefaultLabelSx = (theme: Theme): SxProps<Theme> => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '21px',
  letterSpacing: '0%',
  color: theme.palette.text.secondary,
  '&.Mui-focused': {
    color: theme.palette.text.secondary
  }
});

export const DefaultSx = {
  marginBottom: '12px',
  borderRadius: '10px'
};
